import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";

export default {
  DoGetUnseenNotificationCount(merchantId) {
    const headers = userInfo.SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;

    return API.peakNotificationAPI
      .get("/GetUnseenNotificationCount", { params: null, headers: headers })
      .then((res) => {
        return res;
      });
  },
  DoGetUnseenNotificationList(merchantId) {
    const headers = userInfo.SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;

    return API.peakNotificationAPI.get("/GetUnseenNotificationList", { headers }).then((res) => {
      return res;
    });
  },
  DoGetSeenNotificationList(merchantId) {
    const headers = userInfo.SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;

    return API.peakNotificationAPI.get("/GetSeenNotificationList", { headers }).then((res) => {
      return res;
    });
  },
  DoGetUnseenNotification(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;
    const params = {
      id: notificationId,
    };
    return API.peakNotificationAPI.get("/GetUnseenNotification", { params, headers }).then((res) => {
      return res;
    });
  },
  DoDeleteSeenNotification(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;
    const input = {
      id: notificationId,
    };
    return API.peakNotificationAPI.post("/DeleteSeenNotification", input, headers).then((res) => {
      return res;
    });
  },
  DoDeleteUnseenNotification(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;
    const input = {
      id: notificationId,
    };
    return API.peakNotificationAPI.post("/DeleteUnseenNotification", input, headers).then((res) => {
      return res;
    });
  },
  DoSetNotificationIsSeen(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;
    const input = {
      id: notificationId,
    };
    return API.peakNotificationAPI.post("/SetNotificationIsSeen", input, headers).then((res) => {
      return res;
    });
  },
  DoSetAllNotificationIsSeen(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;
    const input = {
      id: notificationId,
    };
    return API.peakNotificationAPI.post("/SetAllNotificationIsSeen", input, headers).then((res) => {
      return res;
    });
  },
  DoUpdateAccessToken() {
    const headers = userInfo.SetHeaderService();
    const input = {
      userId: userInfo.UserId(),
    };
    return API.peakNotificationAPI.post("/UpdateAccessToken", input, headers).then((res) => {
      return res;
    });
  },
};
